import _ from 'underscore';
import {
  campaignApiErrorCodeToErrorNumberMapping,
  campaignApiErrorCodeToErrorMessageMapping,
  campaignApiErrorCodeToErrorFormatMapping,
  campaignApiErrorCodeToPropertyMapping,
  errorNumberToErrorMessageMapping,
  errorNumberToErrorFormatMapping,
  audienceErrorMessageMap,
} from './error-mapping';
import {
  CampaignEditorialError,
  CampaignApiError,
} from './error-types';
import {
  getEditorialErrorMessage
} from './get-editorial-error';

export function getCampaignApiErrorProperty(errorCode, property) {
  return _.isEmpty(property) && !_.isEmpty(errorCode) ?
    (campaignApiErrorCodeToPropertyMapping[errorCode] || '') :
    property;
}

export function getCampaignApiErrorMessageWithErrorCode(errorCode, i18n) {
  const errorNumber = campaignApiErrorCodeToErrorNumberMapping[errorCode];
  const errorMessage = campaignApiErrorCodeToErrorMessageMapping[errorCode];

  const message =
    // get error message from error number
    (errorNumber &&
      errorNumberToErrorMessageMapping[errorNumber] &&
      i18n.getString(errorNumberToErrorMessageMapping[errorNumber]))
    // get error message from error code
    || (errorMessage &&
      i18n.getString(errorMessage));

  return message;
}

export function getCampaignApiErrorFormatWithErrorCode(errorCode) {
  const errorNumber = campaignApiErrorCodeToErrorNumberMapping[errorCode];
  const errorMessage = campaignApiErrorCodeToErrorMessageMapping[errorCode];

  if (errorNumber && errorNumberToErrorMessageMapping[errorNumber]) {
    return errorNumberToErrorFormatMapping[errorNumber];
  } else if (errorMessage) {
    return campaignApiErrorCodeToErrorFormatMapping[errorCode];
  }

  return undefined;
}

// Odata Error
export const getODataErrors = (
  errs,
  i18n,
  activityLogger
) => _.map(errs, ({
  '@odata.type': odataType,
  Code,
  Property,
  DisapprovedText,
  IsAppealable,
}) => {
  if (odataType === '#Model.ApiEditorialError') {
    const message = getEditorialErrorMessage(Code, i18n, activityLogger);

    return new CampaignEditorialError(message, Property, Code, DisapprovedText, IsAppealable, true);
  }

  const message = getCampaignApiErrorMessageWithErrorCode(`Error_Campaign_API_${Code}`, i18n) || Code;
  const property = getCampaignApiErrorProperty(Code, Property);

  return new CampaignApiError(message, property, Code);
});

export const getAudienceErrorMessage = (errorCode, i18n) =>
  i18n.getString(audienceErrorMessageMap[errorCode] || audienceErrorMessageMap.DefaultError);
